export default {
  id: 'EnrollClassModal',
  code: 'CN',
  text: {
    'Lesson {lesson_number}': '课节 {lesson_number}',
    'Failed to complete the request because following students have conflicted schedules:': '未能成功加入班级，下列学员的时间与已有课程有冲突',
    'Failed To Complete Request': '加入班级失败',
    'Selected {selectedLessons}/{totalLessons} Lessons': '已选择 {selectedLessons}/{totalLessons} 课节',
    'Unselect All Lessons': '取消勾选所有未上课节',
    'Select All Lessons': '勾选所有未上课节',
    'No Lessons': '暂无课节'
  },
}



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/locale.js